import styled from 'styled-components'

export const InputLineContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  margin-top: 10px;
  margin-bottom: 5px;
  align-items: center;
  justify-content: space-between;
`
